import React, { useEffect, useState } from "react";

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function CountDown(props: {
  initialMinute?: number;
  initialSeconds?: number;
  onTimerEnd?: () => Promise<void> | void;
  getInterval?: (interval: NodeJS.Timeout) => void;
  style?: React.CSSProperties;
}) {
  const { initialMinute = 0, initialSeconds = 0 } = props;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
          props.onTimerEnd?.();
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    props.getInterval?.(myInterval);
    return () => {
      clearInterval(myInterval);
    };
  });

  return (
    <>
      <div style={props.style}>
        {" "}
        {minutes === 0 ? null : `${minutes}:`}
        {seconds < 10 ? `0${seconds}` : seconds}
      </div>
    </>
  );
}
